import { render } from "./Image.vue?vue&type=template&id=062028d1&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=062028d1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-062028d1"

export default script